(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carasel_handler_v2"] && !Shopify.designMode) return;
  try {
    // this handles the quick select of vertical slider
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 992) return;

    document.querySelectorAll('.caresel_container').forEach(function (carousel) {
      const thumbSlides = Array.from(carousel.querySelectorAll('.thumb_slider .swiper-slide'));
      const verticalWrapper = carousel.querySelector('.swiper-vertical-wrapper');
      const verticalItems = Array.from(carousel.querySelectorAll('.vertical-swiper-item'));

      if (!verticalWrapper || !thumbSlides.length || !verticalItems.length) return;

      // Track when we're scrolling because of a click
      let isProgrammaticScroll = false;
      let programmaticTargetTop = null;

      // Helper: set active thumb based on media index
      function setActiveThumbByIndex(index) {
        thumbSlides.forEach((t) => t.classList.remove('is-active'));
        const match = thumbSlides.find((t) => t.getAttribute('data-media-index') === String(index));
        if (match) match.classList.add('is-active');
      }

      // ---------- CLICK → SCROLL ----------
      thumbSlides.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          const index = thumb.getAttribute('data-media-index');
          const target = carousel.querySelector('.vertical-swiper-item[data-media-index="' + index + '"]');

          if (!target) return;

          // Calculate scrollTop so the target is centered in the wrapper
          const wrapperRect = verticalWrapper.getBoundingClientRect();
          const itemRect = target.getBoundingClientRect();

          const currentScrollTop = verticalWrapper.scrollTop;
          // Item's offset within the wrapper (including current scroll)
          const itemOffsetWithinWrapper = itemRect.top - wrapperRect.top + currentScrollTop;

          const targetScrollTop =
            itemOffsetWithinWrapper - (verticalWrapper.clientHeight / 2 - target.offsetHeight / 2);

          // Clamp within bounds just in case
          const maxScroll = verticalWrapper.scrollHeight - verticalWrapper.clientHeight;
          const finalScrollTop = Math.max(0, Math.min(targetScrollTop, maxScroll));

          isProgrammaticScroll = true;
          programmaticTargetTop = finalScrollTop;

          verticalWrapper.scrollTo({
            top: finalScrollTop,
            behavior: 'smooth',
          });

          // Keep the active state on the clicked thumb
          setActiveThumbByIndex(index);
        });
      });

      // ---------- SCROLL → ACTIVE THUMB ----------
      let scrollTicking = false;

      verticalWrapper.addEventListener('scroll', function () {
        if (scrollTicking) return;
        scrollTicking = true;

        window.requestAnimationFrame(function () {
          // If we're in a programmatic scroll from a click,
          // don't change the active item yet
          if (isProgrammaticScroll) {
            if (programmaticTargetTop !== null && Math.abs(verticalWrapper.scrollTop - programmaticTargetTop) < 2) {
              // We've reached (or basically reached) the target
              isProgrammaticScroll = false;
              programmaticTargetTop = null;
            }

            scrollTicking = false;
            return;
          }

          const wrapperRect = verticalWrapper.getBoundingClientRect();
          const wrapperCenter = wrapperRect.top + wrapperRect.height / 2;

          // Find the vertical item whose center is closest to the wrapper center
          let closestItem = null;
          let closestDistance = Infinity;

          verticalItems.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const itemCenter = rect.top + rect.height / 2;
            const distance = Math.abs(itemCenter - wrapperCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestItem = item;
            }
          });

          if (closestItem) {
            const index = closestItem.getAttribute('data-media-index');
            setActiveThumbByIndex(index);
          }

          scrollTicking = false;
        });
      });

      // Optional: set initial active state
      setActiveThumbByIndex(0);
    });
  });

  // handle vertical scroll with drag (desktop only)
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 992) return;

    const slider = document.querySelector('.swiper-vertical-wrapper');
    if (!slider) return;

    // Touch support
    let touchStartY;
    let touchScrollTop;

    slider.addEventListener('touchstart', function (e) {
      const touch = e.touches[0];
      touchStartY = touch.pageY - slider.offsetTop;
      touchScrollTop = slider.scrollTop;
    });

    slider.addEventListener('touchmove', function (e) {
      const touch = e.touches[0];
      const y = touch.pageY - slider.offsetTop;
      const walk = (y - touchStartY) * 1.5;
      slider.scrollTop = touchScrollTop - walk;
    });
  });

  // Mobile horizontal slider with CSS scroll snap and wrap-around
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 992) return; // Only on mobile

    document.querySelectorAll('.caresel_container').forEach(function (carousel) {
      const wrapper = carousel.querySelector('.swiper-vertical-wrapper');
      const itemsContainer = carousel.querySelector('.swiper-vertical-items');
      let originalSlides = Array.from(itemsContainer.querySelectorAll('.vertical-swiper-item'));
      const dots = Array.from(carousel.querySelectorAll('.carousel_dot'));

      if (!wrapper || !itemsContainer || !originalSlides.length || !dots.length) return;

      // 1. GET ACCURATE DIMENSIONS
      const slideWidth = originalSlides[0].offsetWidth;
      const style = window.getComputedStyle(itemsContainer);
      const gap = parseFloat(style.gap) || 0;
      const singleUnit = slideWidth + gap;

      // --- CHANGE 1: Calculate the offset to center the slide ---
      // (Viewport Width - Slide Width) / 2 = The space needed on the left to center it
      const wrapperWidth = wrapper.clientWidth;
      const centerOffset = (wrapperWidth - slideWidth) / 2;

      // 2. CLONE SLIDES
      const firstClone = originalSlides[0].cloneNode(true);
      const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);

      firstClone.classList.add('is-clone');
      lastClone.classList.add('is-clone');

      itemsContainer.appendChild(firstClone);
      itemsContainer.insertBefore(lastClone, originalSlides[0]);

      const allSlides = Array.from(itemsContainer.querySelectorAll('.vertical-swiper-item'));

      // 3. SET INITIAL POSITION
      setTimeout(() => {
        wrapper.style.scrollBehavior = 'auto';
        // --- CHANGE 2: Subtract offset to center the initial slide ---
        wrapper.scrollLeft = singleUnit - centerOffset;
      }, 0);

      // -------------------------------------------------------
      // HELPER: DOTS
      // -------------------------------------------------------
      function setActiveDot(realIndex) {
        dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === realIndex);
        });
      }

      // -------------------------------------------------------
      // SCROLL HANDLER
      // -------------------------------------------------------
      let isScrolling = false;
      let scrollTimeout;

      wrapper.addEventListener('scroll', () => {
        if (isScrolling) return;

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const currentScroll = wrapper.scrollLeft;

          // --- CHANGE 3: Add offset back to calculate accurate index ---
          // We add the offset back to normalize the position before dividing by width
          const index = Math.round((currentScroll + centerOffset) / singleUnit);

          const totalOriginals = originalSlides.length;

          // TELEPORT: If at index 0 (Clone of Last)
          if (index === 0) {
            wrapper.style.scrollBehavior = 'auto';
            // --- CHANGE 4: Apply offset to teleport targets ---
            wrapper.scrollLeft = totalOriginals * singleUnit - centerOffset;
            setActiveDot(totalOriginals - 1);
          }
          // TELEPORT: If at last index (Clone of First)
          else if (index === totalOriginals + 1) {
            wrapper.style.scrollBehavior = 'auto';
            // --- CHANGE 4: Apply offset to teleport targets ---
            wrapper.scrollLeft = singleUnit - centerOffset;
            setActiveDot(0);
          }
          // NORMAL SCROLL
          else {
            setActiveDot(index - 1);
          }
        }, 60);
      });

      // -------------------------------------------------------
      // CLICK DOTS
      // -------------------------------------------------------
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          wrapper.style.scrollBehavior = 'smooth';
          // --- CHANGE 4: Apply offset to dot click target ---
          wrapper.scrollLeft = (i + 1) * singleUnit - centerOffset;
          setActiveDot(i);

          setTimeout(() => {
            wrapper.style.scrollBehavior = 'auto';
          }, 500);
        });
      });

      // -------------------------------------------------------
      // ZOOM LOGIC (Unchanged)
      // -------------------------------------------------------
      function attachZoom(slide) {
        const img = slide.querySelector('img');
        if (!img) return;
        const ZOOM_SCALE = 2;
        let isZoomed = false;
        let startX = 0,
          startY = 0,
          lastTranslateX = 0,
          lastTranslateY = 0;

        img.style.transition = 'transform 0.25s ease, transform-origin 0.25s ease';

        function applyTransform(tx, ty) {
          img.style.transform = `translate(${tx}px, ${ty}px) scale(${ZOOM_SCALE})`;
        }

        img.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          isZoomed = !isZoomed;

          if (!isZoomed) {
            img.classList.remove('is-zoomed');
            img.style.transition = 'transform 0.25s ease, transform-origin 0.25s ease';
            img.style.transform = '';
            lastTranslateX = 0;
            lastTranslateY = 0;
            wrapper.style.overflowX = 'auto';
            wrapper.style.scrollSnapType = 'x mandatory';
            return;
          }

          img.classList.add('is-zoomed');
          wrapper.style.overflowX = 'hidden';
          wrapper.style.scrollSnapType = 'none';
          img.style.transformOrigin = '50% 50%';
          setTimeout(() => {
            img.style.transition = '0s';  
          }, 25);
          lastTranslateX = 0;
          lastTranslateY = 0;
          applyTransform(lastTranslateX, lastTranslateY);
        });

        slide.addEventListener('touchstart', (e) => {
          if (isZoomed) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          }
        });

        slide.addEventListener('touchmove', (e) => {
          if (!isZoomed) return;
          if (e.cancelable) e.preventDefault();
          const deltaX = e.touches[0].clientX - startX;
          const deltaY = e.touches[0].clientY - startY;
          let newX = lastTranslateX + deltaX;
          let newY = lastTranslateY + deltaY;

          const rect = slide.getBoundingClientRect();
          const maxOffsetX = (rect.width * (ZOOM_SCALE - 1)) / 2;
          const maxOffsetY = (rect.height * (ZOOM_SCALE - 1)) / 2;

          newX = Math.max(-maxOffsetX, Math.min(maxOffsetX, newX));
          newY = Math.max(-maxOffsetY, Math.min(maxOffsetY, newY));
          applyTransform(newX, newY);
        });

        slide.addEventListener('touchend', (e) => {
          if (!isZoomed) return;
          const deltaX = e.changedTouches[0].clientX - startX;
          const deltaY = e.changedTouches[0].clientY - startY;
          lastTranslateX += deltaX;
          lastTranslateY += deltaY;

          const rect = slide.getBoundingClientRect();
          const maxOffsetX = (rect.width * (ZOOM_SCALE - 1)) / 2;
          const maxOffsetY = (rect.height * (ZOOM_SCALE - 1)) / 2;
          lastTranslateX = Math.max(-maxOffsetX, Math.min(maxOffsetX, lastTranslateX));
          lastTranslateY = Math.max(-maxOffsetY, Math.min(maxOffsetY, lastTranslateY));
          applyTransform(lastTranslateX, lastTranslateY);
        });
      }

      allSlides.forEach((slide) => attachZoom(slide));
      setActiveDot(0);
    });
  });

  // Desktop Zoom on product images
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 992) return; // Desktop only

    const mediaImages = document.querySelectorAll('.caresel_container .vertical-swiper-item img');
    const ZOOM_SCALE = 2;

    mediaImages.forEach((img) => {
      const container = img.closest('.vertical-swiper-item');
      if (!container) return;

      let isZoomed = false;
      let isDragging = false;

      // New variables to track if a drag occurred
      let hasMoved = false;
      let dragStartClientX = 0;
      let dragStartClientY = 0;

      // Coordinates calculations
      let startX, startY;
      let translateX = 0,
        translateY = 0;

      // 1. Mouse Down: Prepare to drag
      container.addEventListener('mousedown', (e) => {
        if (!isZoomed) return;

        isDragging = true;
        hasMoved = false; // Reset movement flag

        // Store raw client coordinates to detect drag distance later
        dragStartClientX = e.clientX;
        dragStartClientY = e.clientY;

        startX = e.clientX - translateX;
        startY = e.clientY - translateY;
        e.preventDefault();
      });

      // 2. Mouse Move: Drag the image
      container.addEventListener('mousemove', (e) => {
        if (!isDragging || !isZoomed) return;

        e.preventDefault();

        // Check if we have moved more than 5 pixels (threshold)
        // This prevents tiny mouse jitters from disabling the click-to-close
        if (!hasMoved) {
          const movedX = Math.abs(e.clientX - dragStartClientX);
          const movedY = Math.abs(e.clientY - dragStartClientY);
          if (movedX > 5 || movedY > 5) {
            hasMoved = true;
          }
        }

        // Calculate new position
        let x = e.clientX - startX;
        let y = e.clientY - startY;

        // --- BOUNDARY CHECKS ---
        const rect = container.getBoundingClientRect();
        const maxOffsetX = (rect.width * ZOOM_SCALE - rect.width) / 2;
        const maxOffsetY = (rect.height * ZOOM_SCALE - rect.height) / 2;

        if (x > maxOffsetX) x = maxOffsetX;
        if (x < -maxOffsetX) x = -maxOffsetX;
        if (y > maxOffsetY) y = maxOffsetY;
        if (y < -maxOffsetY) y = -maxOffsetY;

        translateX = x;
        translateY = y;

        img.style.transform = `translate(${x}px, ${y}px) scale(${ZOOM_SCALE})`;
      });

      // 3. Mouse Up / Leave: Stop dragging
      const stopDrag = () => {
        isDragging = false;
      };
      container.addEventListener('mouseup', stopDrag);
      container.addEventListener('mouseleave', stopDrag);

      // 4. Click: Toggle Zoom
      container.addEventListener('click', (e) => {
        if (isZoomed) {
          // FIX: If we dragged the image, do NOT reset zoom.
          if (hasMoved) {
            return;
          }
          resetZoom();
        } else {
          // Zoom In
          isZoomed = true;
          img.classList.add('is-zoomed');
          img.style.transform = `scale(${ZOOM_SCALE})`;

          const rect = img.getBoundingClientRect();

          // Where the user clicked, relative to the image
          const clickX = e.clientX - rect.left;
          const clickY = e.clientY - rect.top;

          // Image center
          const centerX = rect.width / 2;
          const centerY = rect.height / 2;

          // How much to translate so the clicked point becomes the center
          const moveX = centerX - clickX;
          const moveY = centerY - clickY;

          // Apply zoom (translation first, then scale)
          img.style.transition = 'transform 0.25s ease';
          img.style.transform = `translate(${moveX}px, ${moveY}px) scale(${ZOOM_SCALE})`;

          // Reset drag coordinates to center
          translateX = moveX;
          translateY = moveY;
          setTimeout(() => {
            img.style.transition = '0s';
          }, 25);
        }
      });

      // Helper to reset everything
      function resetZoom() {
        isZoomed = false;
        isDragging = false;
        hasMoved = false;
        img.classList.remove('is-zoomed');
        img.style.transition = 'transform 0.25s ease, transform-origin 0.25s ease';
        container.style.cursor = 'zoom-in';
        img.style.transform = 'translate(0px, 0px) scale(1)';
        translateX = 0;
        translateY = 0;
      }

      // Close on click outside
      document.addEventListener('click', (e) => {
        if (isZoomed && !container.contains(e.target)) {
          resetZoom();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
